(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-final-form-generator", [], factory);
	else if(typeof exports === 'object')
		exports["react-final-form-generator"] = factory();
	else
		root["react-final-form-generator"] = factory();
})(window, function() {
return 